export default class Address {
  public idAddress: number = 0;
  public addressLine1: string = "";
  public addressLine2: string = "";
  public city: string = "";
  public state: string = "";
  public zip: string = "";
  public country: string = "";

  static toString(address: Address) {
    if (address == null) {
      return "";
    }

    return `${address.addressLine1 ?? ""} ${address.addressLine2 ?? ""} ${
      address.city ?? ""
    } ${address.zip ?? ""} ${address.state ?? ""} ${address.country ?? ""}`;
  }

  static getAddressLines(address: Address) {
    if (address == null) {
      return "";
    }

    var input: string[] = [];
    if (address.addressLine1) input.push(address.addressLine1);
    if (address.addressLine2) input.push(address.addressLine2);
    return input.join(", ");
  }

  static getCityStateZipCode(address: Address) {
    if (address == null) {
      return "";
    }
    var input: string[] = [];
    if (address.city) input.push(address.city);
    if (address.state) input.push(address.state);
    if (address.zip) input.push(address.zip);

    return input.join(", ");
  }
}
